import { render, staticRenderFns } from "./a3.vue?vue&type=template&id=45d11d36&scoped=true"
import script from "./a3.vue?vue&type=script&lang=js"
export * from "./a3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d11d36",
  null
  
)

export default component.exports